"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeFilter = void 0;
var __1 = require("..");
var ListUtil_1 = require("../core/ListUtil");
/** if it returns undefined, node will be skipped */
var NodeFilter = /** @class */ (function () {
    function NodeFilter() {
    }
    NodeFilter.exclude = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i] = arguments[_i];
        }
        return new (ExcludeFilter.bind.apply(ExcludeFilter, __spreadArrays([void 0], patterns)))();
    };
    NodeFilter.mask = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i] = arguments[_i];
        }
        return new (MaskFilter.bind.apply(MaskFilter, __spreadArrays([void 0], patterns)))();
    };
    return NodeFilter;
}());
exports.NodeFilter = NodeFilter;
;
var RegexFilter = /** @class */ (function () {
    function RegexFilter() {
        var strPatterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            strPatterns[_i] = arguments[_i];
        }
        this.pathPatterns = [];
        this.addPatterns.apply(this, strPatterns);
    }
    RegexFilter.prototype.apply = function (n) {
        if (!this.matches(n.pathAsString))
            return n;
        return this.transform(n);
    };
    RegexFilter.prototype.addPatterns = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i] = arguments[_i];
        }
        if (patterns != null)
            for (var _a = 0, patterns_1 = patterns; _a < patterns_1.length; _a++) {
                var ptn = patterns_1[_a];
                this.pathPatterns.push(new RegExp(ptn));
            }
    };
    RegexFilter.prototype.matches = function (path) {
        return ListUtil_1.ListUtil.exists(this.pathPatterns, function (p) { return p.test(path); });
    };
    return RegexFilter;
}());
var ExcludeFilter = /** @class */ (function (_super) {
    __extends(ExcludeFilter, _super);
    function ExcludeFilter() {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i] = arguments[_i];
        }
        return _super.apply(this, patterns) || this;
    }
    ExcludeFilter.prototype.transform = function (n) { return undefined; };
    return ExcludeFilter;
}(RegexFilter));
var MaskFilter = /** @class */ (function (_super) {
    __extends(MaskFilter, _super);
    function MaskFilter() {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i] = arguments[_i];
        }
        return _super.apply(this, patterns) || this;
    }
    MaskFilter.prototype.transform = function (n) {
        if (n.value == null && !n.hasChildren())
            return n;
        return n.cloneOfSimpleType(this.getMaskStr(n));
    };
    MaskFilter.prototype.getMaskStr = function (n) {
        var _a;
        switch (n.type) {
            case __1.TDNodeType.SIMPLE: return "<Masked:len=" + ((_a = n.value) === null || _a === void 0 ? void 0 : _a.toString().length) + ">";
            case __1.TDNodeType.MAP: return "{Masked:size=" + n.getChildrenSize() + "}";
            case __1.TDNodeType.ARRAY: return "[Masked:length=" + n.getChildrenSize() + "]";
        }
        return "[Masked]"; // Shouldn't happen
    };
    return MaskFilter;
}(RegexFilter));
//# sourceMappingURL=NodeFilter.js.map